// extracted by mini-css-extract-plugin
export default {"gridbox":"hflprojects_gridbox__8RI3W","divcont":"hflprojects_divcont__LjjCm","imagecont":"hflprojects_imagecont__9wMpY","imagehover":"hflprojects_imagehover__sShDx"};